<template>
    <button type="button"
            class="flex items-center font-bold c-grid-table-sort"
            :class="{'c-grid-table-sort__active': sortColumn === sortOption}"
            @click="clickSort(sortOption)">
        <span class="c-grid-table-sort--name"
              :title="label">
            {{ label }}
        </span>
        <div class="flex flex-col">
            <CIcon class="ml-6 mt-2"
                   height="4"
                   width="8"
                   name="arrow-up"
                   :class="{'opacity-40': !(sortColumn === sortOption && sortOrder === ListSortDirection.Ascending) }"/>
            <CIcon class="ml-6 mt-2"
                   height="4"
                   width="8"
                   name="arrow-down"
                   :class="{'opacity-40': !(sortColumn === sortOption && sortOrder === ListSortDirection.Descending) }"/>
        </div>
    </button>
</template>

<script setup lang="ts">
import { ListSortDirection } from '@/types/apiServerContract';
interface GridTableSortProps {
    label: string;
    sortOrder: ListSortDirection | null;
    sortColumn: any | null;
    sortOption: any | null;
}
const props = defineProps<GridTableSortProps>();

const emit = defineEmits<{
    (e: 'sortOrder', sortOrder: ListSortDirection): void,
    (e: 'sortColumn', sortColumn: any): void,
}>();

function clickSort(sortColumn: any) {
    if (props.sortColumn === sortColumn) {
        // Same column clicked, switch sort order
        const sortOrder = props.sortOrder === ListSortDirection.Ascending ? ListSortDirection.Descending : ListSortDirection.Ascending;
        emit('sortOrder', sortOrder);
    } else {
        // Change sort column
        emit('sortColumn', sortColumn);
    }
}
</script>
